(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.cart-form');
    if (!form) return;
    var status = form.querySelector('[data-tt-cart-status]');
    var checkout = form.querySelector('[name="checkout"]');
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-tt-cart-role]'));
    function validateReservations() {
      var groups = {};
      var problem = '';
      rows.forEach(function (row) {
        var id = row.dataset.ttCartReservation;
        if (!id) { problem = 'A Tea & Tales item was added outside registration. Remove it and register again.'; return; }
        if (!groups[id]) groups[id] = [];
        groups[id].push(row);
      });
      var memberPerMeeting = {};
      Object.keys(groups).forEach(function (id) {
        var pair = groups[id];
        var seat = pair.find(function (row) { return row.dataset.ttCartRole === 'seat'; });
        var experience = pair.find(function (row) { return row.dataset.ttCartRole === 'experience'; });
        if (pair.length !== 2 || !seat || !experience ||
            seat.dataset.ttCartQuantity !== experience.dataset.ttCartQuantity ||
            Number(seat.dataset.ttCartNames) !== Number(seat.dataset.ttCartQuantity) ||
            seat.dataset.ttCartDate !== experience.dataset.ttCartDate) {
          problem = 'A Tea & Tales reservation is incomplete. Remove it and register again.';
        }
        if (experience && experience.dataset.ttCartMember === 'true' && Number(experience.dataset.ttCartQuantity) > 1) {
          problem = 'The member benefit covers only one active member. Remove this reservation and book other guests separately.';
        }
        if (experience && experience.dataset.ttCartMember === 'true') {
          var meetingDate = experience.dataset.ttCartDate;
          memberPerMeeting[meetingDate] = (memberPerMeeting[meetingDate] || 0) + Number(experience.dataset.ttCartQuantity);
        }
        if (seat && (!window.TeaTalesAvailability || window.TeaTalesAvailability.classifyMeeting({
          title: seat.dataset.ttCartDate, startTime: '18:00', available: true,
          inventoryManagement: 'shopify', inventoryQuantity: Number(seat.dataset.ttCartQuantity)
        }, new Date()) !== 'open')) {
          problem = 'Online reservations for this Tea & Tales meeting have closed. Remove the reservation before checkout.';
        }
      });
      if (Object.keys(memberPerMeeting).some(function (date) { return memberPerMeeting[date] > 1; })) {
        problem = 'Only one member-benefit seat can be reserved per meeting in this cart. Remove the extra reservation.';
      }
      status.hidden = !problem;
      status.textContent = problem;
      checkout.disabled = !!problem;
      return !problem;
    }
    validateReservations();
    document.addEventListener('DOMContentLoaded', validateReservations);
    window.addEventListener('focus', validateReservations);
    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter.name === 'checkout' && !validateReservations()) event.preventDefault();
    });
    form.querySelectorAll('[data-tt-remove]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var pair = rows.filter(function (row) { return row.dataset.ttCartReservation === link.dataset.ttRemove; });
        var updates = {};
        pair.forEach(function (row) { updates[row.dataset.ttCartKey] = 0; });
        link.style.pointerEvents = 'none';
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not remove this reservation. Please refresh and try again.');
          window.location.reload();
        }).catch(function (error) {
          link.style.pointerEvents = '';
          status.hidden = false;
          status.textContent = error.message;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-variants-json]');
    if (!section) return;

    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    var addBtn = form.querySelector('button[name="add"]');
    var priceEl = section.querySelector('.product-price');
    var selects = form.querySelectorAll('.variant-selector select');

    var variants = JSON.parse(section.getAttribute('data-variants-json') || '[]');

    function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    }

    function currentSelection() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function matchVariant(selected) {
      if (!selects.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateVariantUI() {
      if (!variantInput || !variants.length) return;
      var v = matchVariant(currentSelection());
      if (!v) return;
      variantInput.value = v.id;
      if (sellingPlanInput) {
        var allocations = v.selling_plan_allocations || [];
        if (allocations.length) sellingPlanInput.value = allocations[0].selling_plan_id;
      }
      section.setAttribute('data-tipo-variant-id', v.id);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (sellingPlanInput ? 'Add Subscription to Cart' : 'Add to Cart')
          : 'Sold Out';
      }
    }

    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', updateVariantUI);
    });

    // Tipo-driven reservation products use their own widget for checkout;
    // skip the AJAX handler so we don't interfere with booking flow.
    if (section.querySelector('[data-tipo-slot-banner]')) return;

    var messageEl = document.createElement('p');
    messageEl.className = 'cart-message';
    messageEl.setAttribute('role', 'status');
    messageEl.setAttribute('aria-live', 'polite');
    messageEl.hidden = true;
    if (addBtn && addBtn.parentNode) {
      addBtn.parentNode.insertBefore(messageEl, addBtn.nextSibling);
    }

    function showMessage(text, kind) {
      messageEl.textContent = text;
      messageEl.className = 'cart-message cart-message--' + kind;
      messageEl.hidden = false;
    }

    function markSoldOut(finalText) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = finalText || 'Sold Out';
      }
      var payBtn = form.querySelector('.shopify-payment-button');
      if (payBtn) payBtn.hidden = true;
    }

    form.addEventListener('submit', function (e) {
      if (!variantInput || !variantInput.value) return;
      e.preventDefault();
      messageEl.hidden = true;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (result) {
          if (result.ok) {
            window.location.href = '/cart';
            return;
          }
          var msg = (result.data && (result.data.description || result.data.message)) || 'Unable to add to cart. Please try again.';
          showMessage(msg, 'error');
          if (/sold out/i.test(msg) || result.status === 422) {
            markSoldOut('Sold Out');
          } else if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }
        })
        .catch(function () {
          showMessage('Could not reach the cart. Please try again.', 'error');
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tea-tales-rsvp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('tt-rsvp-form');
    if (!form) return;

    var status = form.querySelector('[data-tt-status]');
    var submit = form.querySelector('[data-tt-submit]');
    var phoneInput = form.querySelector('#tt-phone');
    var guestCount = form.querySelector('[data-tt-guest-count]');
    var guestFields = form.querySelector('[data-tt-guest-names]');

    function renderGuestFields() {
      var count = Number(guestCount.value);
      var existing = Array.prototype.map.call(guestFields.querySelectorAll('input'), function (field) { return field.value; });
      guestFields.replaceChildren();
      for (var i = 0; i < count; i++) {
        var label = document.createElement('label');
        label.className = 'tt-guest-label';
        label.textContent = 'Guest ' + (i + 1) + ' full name';
        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'tt-phone-input';
        input.name = 'tt-guest-' + (i + 1);
        input.maxLength = 100;
        input.required = true;
        input.value = existing[i] || '';
        label.appendChild(input);
        guestFields.appendChild(label);
      }
    }
    guestCount.addEventListener('change', renderGuestFields);
    function updateGuestLimit() {
      var experience = form.querySelector('input[name="tt-experience"]:checked');
      var meeting = form.querySelector('input[name="tt-meeting"]:checked');
      var member = experience && experience.dataset.ttMemberExperience === 'true';
      var seats = meeting ? Number(meeting.dataset.ttInventoryQuantity) : 20;
      Array.prototype.forEach.call(guestCount.options, function (option) {
        option.disabled = Number(option.value) > seats || (!!member && Number(option.value) > 1);
      });
      if (guestCount.selectedOptions[0] && guestCount.selectedOptions[0].disabled) {
        guestCount.value = '1';
        renderGuestFields();
        status.textContent = member
          ? 'The member benefit covers one active member. Reserve other guests separately.'
          : 'The selected meeting has fewer seats available. Please review your guest names.';
      }
    }
    form.querySelectorAll('input[name="tt-experience"]').forEach(function (input) {
      input.addEventListener('change', updateGuestLimit);
    });
    form.querySelectorAll('input[name="tt-meeting"]').forEach(function (input) {
      input.addEventListener('change', updateGuestLimit);
    });
    document.querySelector('.tt-rsvp').addEventListener('tt:availability-updated', updateGuestLimit);
    renderGuestFields();
    updateGuestLimit();

    // Normalise to E.164 so the sync script can write it straight onto the customer record.
    // Shopify expects +1XXXXXXXXXX; anything that isn't a plausible US number is rejected here
    // rather than stored badly.
    function normalisePhone(raw) {
      var digits = String(raw || '').replace(/[^0-9]/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
      if (digits.length === 10) return '+1' + digits;
      return null;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var meeting = form.querySelector('input[name="tt-meeting"]:checked');
      var experience = form.querySelector('input[name="tt-experience"]:checked');

      if (!meeting || !experience) {
        status.textContent = 'Choose a meeting and an experience to continue.';
        return;
      }

      // Recheck on submit: a page left open overnight must not reserve yesterday's seat.
      var availability = window.TeaTalesAvailability;
      if (!availability || availability.classifyMeeting({
        title: meeting.dataset.meeting,
        startTime: document.querySelector('.tt-rsvp').dataset.ttMeetingStart,
        available: meeting.dataset.ttMeetingAvailable === 'true',
        inventoryManagement: meeting.dataset.ttInventoryManagement,
        inventoryQuantity: meeting.dataset.ttInventoryQuantity
      }, new Date()) !== 'open') {
        status.textContent = 'That meeting is no longer open for reservations. Please refresh the page.';
        return;
      }

      var guestNames = Array.prototype.map.call(guestFields.querySelectorAll('input'), function (input) {
        return input.value.trim().replace(/\s+/g, ' ');
      });
      var availableSeats = Number(meeting.dataset.ttInventoryQuantity);
      if (guestNames.length !== Number(guestCount.value) || guestNames.length > availableSeats) {
        status.textContent = 'Choose no more guests than the seats currently available.';
        guestCount.focus();
        return;
      }
      if (experience.dataset.ttMemberExperience === 'true' && guestNames.length > 1) {
        status.textContent = 'The member benefit covers only one active member. Reserve other guests separately.';
        return;
      }
      if (guestNames.some(function (name) { return name.split(' ').length < 2; })) {
        status.textContent = 'Please enter the full name of every guest.';
        var incomplete = Array.prototype.find.call(guestFields.querySelectorAll('input'), function (input) {
          return input.value.trim().split(/\s+/).length < 2;
        });
        if (incomplete) incomplete.focus();
        return;
      }

      var phone = normalisePhone(phoneInput && phoneInput.value);
      if (!phone) {
        status.textContent = 'Please enter a 10-digit phone number so we can reach you about this meeting.';
        if (phoneInput) phoneInput.focus();
        return;
      }

      submit.disabled = true;
      status.textContent = 'Adding your reservation to the cart.';

      var reservationId = 'TT-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      var sharedProperties = { '_Tea & Tales reservation': reservationId, 'Meeting date': meeting.dataset.meeting };
      var seatProperties = Object.assign({}, sharedProperties, { 'Contact phone': phone });
      guestNames.forEach(function (name, index) { seatProperties['Guest ' + (index + 1) + ' full name'] = name; });

      // Both lines in one request. If this failed partway the cart could hold an experience
      // without its seat, which would break the capacity count.
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            // The phone rides on the seat line: the seat is the attendance record, so the contact
            // number belongs with it. It surfaces on the order and in POS as a line item property.
            {
              id: Number(meeting.value),
              quantity: guestNames.length,
              properties: seatProperties
            },
            { id: Number(experience.value), quantity: guestNames.length, properties: sharedProperties }
          ]
        })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || 'That seat is no longer available.');
            return body;
          });
        })
        .then(function () {
          status.textContent = 'Seat held. Taking you to your cart…';
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (error) {
          submit.disabled = false;
          status.textContent = error.message + ' Please pick another meeting, or call the shop.';
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
